import { useComparer } from '@/hooks/useComparer';
import { useExpandable } from '@/hooks/useExpandable';
import { ComparerCommon } from '@/types/comparer';
import { Fragment, type FC } from 'react';
import { getVisibleParams } from '../comparerUtils/comparerUtils';
import ModifiedProps from '../comparerShared/ModifiedProps';
import StatusRow from '../comparerShared/StatusRow';

type CategoryChangesProps = { category: ComparerCommon; type: string };

const CategoryChanges: FC<CategoryChangesProps> = ({ category, type }) => {
  const { showUnchanged } = useComparer();
  const [open, setOpen] = useExpandable(category.status === 'modified');

  if (!showUnchanged && category.status === 'unchanged') return <Fragment key={category.id}></Fragment>;

  const visibleParams = getVisibleParams(category.changedProps, showUnchanged);
  const expandable = visibleParams.length > 0;

  return (
    <>
      <StatusRow
        status={category.status}
        title={`${category.id} (${type})`}
        label={category.label}
        open={open}
        setOpen={expandable ? setOpen : undefined}
      />
      {open &&
        expandable &&
        visibleParams.map((change, index) => <ModifiedProps key={`${change.key}-${index}`} param={change} />)}
    </>
  );
};

export default CategoryChanges;
